import {
  ASSIGNMENT_STATUS,
  ISG_REPORT_VIEW_OPTIONS,
} from '../../../../../utils/constants';
import { getStudentFullName } from '../../utils';
import s from './Body.module.css';
import {
  AssignmentLabelCell,
  DateCell,
  DueDateCell,
  MobileAssignmentLabelCell,
  ScoreCell,
  TimeSpentCell,
} from './TableCells';

export const CategoryRow = ({
  currentStudent,
  assignment,
  settings,
  user,
  isTotal,
  studentId,
  getLaunchUrl,
  handleLocalLaunch,
  getStudentReportLink,
  hasStudentReport,
  isMobile,
  showPercent,
  isDropdownOpen,
  categoryName,
}) => {
  if (assignment?.status === ASSIGNMENT_STATUS.UNASSIGNED) {
    return null;
  }

  const studentFullName = getStudentFullName(currentStudent);

  if (isTotal && isMobile) {
    return (
      <div className={`${s.mobileTableRow} ${s.categoryTotal}`}>
        <div className={s.categoryTotalLabel}>{categoryName} Total</div>
        <ScoreCell
          studentFullName={studentFullName}
          assignment={assignment}
          settings={settings}
          getLaunchUrl={getLaunchUrl}
          isMobile
          isTotal={isTotal}
          categoryName={categoryName}
          isgCurrentView={ISG_REPORT_VIEW_OPTIONS.CATEGORY}
        />
      </div>
    );
  }

  if (isMobile) {
    return (
      <div className={s.mobileTableRow} key={assignment.id}>
        <MobileAssignmentLabelCell
          assignment={assignment}
          user={user}
          getLaunchUrl={getLaunchUrl}
          handleLocalLaunch={handleLocalLaunch}
          studentId={studentId}
          isDropdownOpen={isDropdownOpen}
        />
        <ScoreCell
          studentFullName={studentFullName}
          assignment={assignment}
          settings={settings}
          user={user}
          getLaunchUrl={getLaunchUrl}
          getStudentReportLink={getStudentReportLink}
          hasStudentReport={hasStudentReport}
          showPercent={showPercent}
          isMobile
          isgCurrentView={ISG_REPORT_VIEW_OPTIONS.CATEGORY}
        />
      </div>
    );
  }

  return (
    <div
      className={`${s.tableRow} ${isTotal && s.totalRow}`}
      key={assignment.id}
      data-test-id="isg-category-row"
    >
      <AssignmentLabelCell
        assignment={assignment}
        user={user}
        getLaunchUrl={getLaunchUrl}
        handleLocalLaunch={handleLocalLaunch}
        isMobile={isMobile}
        isDropdownOpen={isDropdownOpen}
      />
      <ScoreCell
        studentFullName={studentFullName}
        assignment={assignment}
        settings={settings}
        user={user}
        getLaunchUrl={getLaunchUrl}
        getStudentReportLink={getStudentReportLink}
        hasStudentReport={hasStudentReport}
        showPercent={showPercent}
        isgCurrentView={ISG_REPORT_VIEW_OPTIONS.CATEGORY}
      />
      <DueDateCell assignment={assignment} />
      <DateCell date={assignment?.dateCompleted} hide={isTotal} />
      <TimeSpentCell assignment={assignment} />
    </div>
  );
};
